/*
 * Elite Cases — página de produto no Focal 13.
 *
 * O tema (product-form.liquid) abre a página sem modelo e sem cor marcados quando não há ?variant= na URL.
 * Este arquivo cuida do resto, usando só os eventos públicos do tema:
 *  - guarda o que o cliente REALMENTE escolheu (clique dele, ou o modelo lembrado da coleção);
 *  - depois de cada redesenho do produto (evento product:rerender), desmarca o que ele ainda não escolheu,
 *    volta o texto "Selecione" e risca só o que não tem estoque para as escolhas reais;
 *  - segura a foto até a cor ser escolhida (a variante que o tema guarda por baixo não troca a foto);
 *  - não deixa comprar enquanto faltar escolher (aviso em cinza; fica vermelho ao tentar comprar);
 *  - lembra o modelo do iPhone entre páginas (sessionStorage 'ecModelo', o mesmo da coleção);
 *  - avisa quando a capa não tem o modelo lembrado, com link para as capas desse iPhone;
 *  - a nota (ec-prova) rola até as avaliações.
 * Página com ?variant= (links de anúncio): o modelo vem marcado e a cor fica em aberto.
 */
(function () {
  if (window.__ecProduto) return;
  window.__ecProduto = true;

  var NOME_MODELO = 'modelo';
  var estados = {}; // por id do formulário

  function picker(formId) { return document.querySelector('variant-picker[form-id="' + formId + '"]'); }
  function noProdutoPrincipal(el) { return !!(el && el.closest && el.closest('.shopify-section--main-product')); }
  function seletores(p) { return p ? Array.prototype.slice.call(p.querySelectorAll('.product-form__option-selector[data-ec-pos]')) : []; }
  function nomeOpcao(sel) { return (sel.getAttribute('data-ec-nome-opcao') || '').trim(); }
  function ehModelo(sel) { return nomeOpcao(sel).toLowerCase() === NOME_MODELO; }
  function radios(sel) { return Array.prototype.slice.call(sel.querySelectorAll('input[type="radio"][data-option-position]')); }
  function caixa(r) { return r.closest('.block-swatch, .color-swatch, .variant-swatch') || r.parentNode; }
  function lembrado() { try { return sessionStorage.getItem('ecModelo') || ''; } catch (e) { return ''; } }
  // só lembra modelos de iPhone (a pulseira do Apple Watch também chama o tamanho de "Modelo")
  function lembrar(v) { if (!/iphone/i.test(v || '')) return; try { sessionStorage.setItem('ecModelo', v); } catch (e) {} }

  function faltando(est) {
    var p = picker(est.formId);
    return seletores(p).filter(function (sel) { return !est.escolhas[sel.getAttribute('data-ec-pos')]; });
  }

  // Tem estoque esta opção, considerando só o que o cliente escolheu nas outras?
  function temEstoque(est, pos, nome) {
    return est.variantes.some(function (v) {
      if (!v.available || v.options[pos - 1] !== nome) return false;
      return Object.keys(est.escolhas).every(function (q) {
        return Number(q) === pos || v.options[q - 1] === est.escolhas[q].nome;
      });
    });
  }

  function aplicar(est) {
    var p = picker(est.formId);
    if (!p) return;
    seletores(p).forEach(function (sel) {
      var pos = Number(sel.getAttribute('data-ec-pos'));
      var esc = est.escolhas[pos];
      radios(sel).forEach(function (r) {
        var marcar = !!esc && r.value === esc.id;
        if (r.checked !== marcar) r.checked = marcar;
        if (est.variantes.length) caixa(r).classList.toggle('is-disabled', !temEstoque(est, pos, r.getAttribute('data-ec-nome')));
      });
      var rotulo = sel.querySelector('.product-form__option-value');
      if (rotulo) rotulo.textContent = esc ? esc.nome : 'Selecione';
      sel.classList.toggle('ec-pendente', !esc);
    });
    avisos(est, p);
  }

  function avisos(est, p) {
    var falta = faltando(est);
    var aviso = p.parentNode.querySelector('.ec-falta[data-form="' + est.formId + '"]');
    if (falta.length) {
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.className = 'ec-falta';
        aviso.setAttribute('data-form', est.formId);
        p.parentNode.insertBefore(aviso, p.nextSibling);
      }
      aviso.textContent = 'Selecione ' + falta.map(function (s) { return nomeOpcao(s).toLowerCase(); }).join(' e ') + ' para continuar';
      aviso.classList.toggle('is-alerta', !!est.alerta);
    } else if (aviso) {
      aviso.remove();
      est.alerta = false;
    }
    // modelo lembrado que esta capa não tem
    var selModelo = seletores(p).filter(ehModelo)[0];
    var nota = p.querySelector('.ec-sem-modelo');
    var guardado = lembrado();
    var naoTem = selModelo && /iphone/i.test(guardado) && !est.escolhas[selModelo.getAttribute('data-ec-pos')] &&
      !radios(selModelo).some(function (r) { return r.getAttribute('data-ec-nome') === guardado; });
    if (naoTem) {
      if (!nota) { nota = document.createElement('p'); nota.className = 'ec-sem-modelo'; selModelo.appendChild(nota); }
      nota.innerHTML = 'Esta capa não tem versão para <b></b>. <a href="/collections/capas-metalicas-1?modelo=' + encodeURIComponent(guardado) + '">Ver capas para o seu iPhone</a>';
      nota.querySelector('b').textContent = guardado;
    } else if (nota) nota.remove();
  }

  // A Shopify completa as opções que faltam com o PRIMEIRO valor da lista, mesmo sem estoque (ex.: Laranja no 18 Pro Max -> "Esgotado").
  // Antes do tema pedir a combinação, marcamos por baixo um valor COM estoque nas opções em aberto; depois do redesenho
  // aplicar() desmarca de novo. O cliente continua vendo "Selecione".
  function completar(est) {
    var p = picker(est.formId);
    if (!p || !est.variantes.length) return;
    var abertos = seletores(p).filter(function (sel) { return !est.escolhas[sel.getAttribute('data-ec-pos')]; });
    if (!abertos.length) return;
    var v = est.variantes.filter(function (x) {
      return x.available && Object.keys(est.escolhas).every(function (q) { return x.options[q - 1] === est.escolhas[q].nome; });
    })[0];
    if (!v) return;
    abertos.forEach(function (sel) {
      var pos = Number(sel.getAttribute('data-ec-pos'));
      radios(sel).forEach(function (r) { r.checked = r.getAttribute('data-ec-nome') === v.options[pos - 1]; });
    });
  }

  // Segurança: se a variante que o tema guarda por baixo está sem estoque e ainda falta escolher algo
  // (ex.: o cliente tocou no modelo antes deste arquivo carregar e a Shopify completou com Laranja esgotada),
  // completa com uma combinação com estoque e pede de novo ao tema.
  function corrigir(est, forcar) {
    if (est.corrigindo || !est.variantes.length) return;
    if (!forcar) {
      if (!faltando(est).length) return;
      var form = document.getElementById(est.formId);
      var campo = form && form.querySelector('[name="id"]');
      var v = campo && est.variantes.filter(function (x) { return String(x.id) === String(campo.value); })[0];
      if (!v || v.available) return;
    }
    var p = picker(est.formId);
    var chave = Object.keys(est.escolhas)[0];
    var r = chave && radios(seletores(p).filter(function (s) { return s.getAttribute('data-ec-pos') === chave; })[0] || p)
      .filter(function (x) { return x.value === est.escolhas[chave].id; })[0];
    if (!r) return;
    est.corrigindo = true;
    setTimeout(function () { est.corrigindo = false; }, 4000);
    r.checked = true;
    r.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function escolher(est, r, porCliente) {
    var sel = r.closest('.product-form__option-selector[data-ec-pos]');
    if (!sel) return;
    est.escolhas[sel.getAttribute('data-ec-pos')] = { id: r.value, nome: r.getAttribute('data-ec-nome') };
    if (ehModelo(sel) && porCliente) lembrar(r.getAttribute('data-ec-nome'));
  }

  function iniciar(p) {
    if (!p || p.__ecIni || !noProdutoPrincipal(p)) return;
    var formId = p.getAttribute('form-id');
    var form = document.getElementById(formId);
    if (!form) return;
    p.__ecIni = true;
    var est = estados[formId] = { formId: formId, escolhas: {}, variantes: [], alerta: false };
    var sem = p.getAttribute('data-ec-sem') === 'true';

    if (sem) {
      // Página aberta sem nada marcado: se já há algo marcado aqui, foi o cliente que tocou antes de este arquivo carregar.
      seletores(p).forEach(function (sel) {
        var r = radios(sel).filter(function (x) { return x.checked; })[0];
        if (r) escolher(est, r, true);
      });
    } else {
      // Página com variante definida (ex.: link de anúncio com ?variant=): vale só o modelo.
      seletores(p).forEach(function (sel) {
        if (!ehModelo(sel)) return;
        var r = radios(sel).filter(function (x) { return x.checked; })[0];
        if (r) escolher(est, r, false);
      });
    }

    // Estoque de todas as combinações: já vem na página (bloco data-ec-variantes do product-form); sem isso, busca pela rede.
    var embutido = p.querySelector('script[data-ec-variantes]');
    var lista = null;
    try { lista = embutido && JSON.parse(embutido.textContent); } catch (e) {}
    if (lista && lista.length) {
      est.variantes = lista.map(function (v) { return { id: v.i, options: v.o, available: v.a }; });
      setTimeout(function () { aplicar(est); marcarLembrado(); }, 0);
    } else {
      fetch('/products/' + p.getAttribute('handle') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (prod) { est.variantes = prod.variants || []; aplicar(est); marcarLembrado(); })
        .catch(function () {});
    }

    // Modelo lembrado da coleção: marca sozinho se esta capa tem esse modelo com estoque.
    function marcarLembrado() {
      if (!sem || Object.keys(est.escolhas).length) return;
      p = picker(formId);
      var guardado = lembrado();
      var selModelo = seletores(p).filter(ehModelo)[0];
      var r = guardado && selModelo && radios(selModelo).filter(function (x) {
        return x.getAttribute('data-ec-nome') === guardado && !caixa(x).classList.contains('is-disabled');
      })[0];
      if (r) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Depois de cada redesenho do tema, volta ao que o cliente escolheu (e confere se a variante por baixo tem estoque).
    form.addEventListener('product:rerender', function () { est.redesenhou = true; setTimeout(function () { aplicar(est); corrigir(est); }, 0); });
    aplicar(est);
    // Quando o tema fica pronto: se o cliente já escolheu algo e o tema ainda não pediu a combinação (tocou antes de o tema
    // carregar), pede agora; senão só confere o estoque da variante por baixo.
    var pronto = function () { setTimeout(function () { corrigir(est, Object.keys(est.escolhas).length > 0 && !est.redesenhou); }, 0); };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('variant-picker').then(pronto); else pronto();
  }

  // Escolha do cliente (o tema escuta o mesmo "change" e pede a combinação ao servidor só com o que está marcado).
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('input[type="radio"][data-option-position]')) return;
    var est = estados[r.getAttribute('form')];
    if (!est) return;
    escolher(est, r, e.isTrusted);
    completar(est);
  }, true);

  // Foto: enquanto a cor (ou outra opção que não seja o modelo) estiver em aberto, a foto não acompanha a variante guardada por baixo.
  window.addEventListener('variant:change', function (e) {
    var form = e.target;
    var est = form && form.getAttribute && estados[form.getAttribute('id')];
    if (!est || !e.detail || !e.detail.variant) return;
    var p = picker(est.formId);
    var abertaNaoModelo = seletores(p).some(function (sel) { return !ehModelo(sel) && !est.escolhas[sel.getAttribute('data-ec-pos')]; });
    if (abertaNaoModelo) e.detail.variant = Object.assign({}, e.detail.variant, { featured_media: null });
  }, true);

  // Compra com opção em aberto: não envia, mostra o que falta.
  function bloquear(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var est = estados[form.getAttribute('id')];
    if (!est) return;
    var falta = faltando(est);
    if (!falta.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    est.alerta = true;
    aplicar(est);
    var aviso = document.querySelector('.ec-falta[data-form="' + est.formId + '"]');
    if (aviso) { aviso.classList.remove('is-pulso'); void aviso.offsetWidth; aviso.classList.add('is-pulso'); }
    falta[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  window.addEventListener('submit', bloquear, true);

  // Nota das avaliações -> rola até o Ryviu
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ec-avaliacoes]');
    if (!a) return;
    var alvo = document.querySelector('.ryviu-widget, ryviu-widget, #ryviu-widget, [id*="ryviu"]');
    if (!alvo) return;
    e.preventDefault();
    alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function varrer() { document.querySelectorAll('variant-picker[data-ec-sem]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer); else varrer();
  // o tema define os elementos depois; garante a inicialização se o picker aparecer mais tarde
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('variant-picker').then(varrer);
})();
